import { Provider } from '@common/types';

export const isExternalProvider = (provider: string | undefined | null) => provider !== Provider.ILS;